import { Injectable } from '@angular/core';
import { SSE } from 'sse.js';
import { AuthService } from '../../authentication/auth.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServerSentService {
  eventSource: SSE;

  constructor(private authService : AuthService) { }
  
  /**
   * Create an event source of POST request
   *
   * @param API url
   * @formData data (file, ...etc.)
   */
  public getEventSourceWithPost(url: string, formData: FormData): SSE {
    return this.buildEventSource(url, 'POST', formData);
  }

  /**
   * Create an event source of GET request
   *
   * @param API url
   */
  public getEventSourceWithGet(url: string): SSE {
    return this.buildEventSource(url, 'GET');
  }

  /**
   * Building the event source
   *
   * @param url  API URL
   * @param meth  (POST, GET, ...etc.)
   * @param formData data
   */
  private buildEventSource(url: string, meth: string, formData?: FormData): SSE {
    const options = this.buildOptions(meth, formData);
    this.eventSource = new SSE(url, options);
    return this.eventSource;
  }

  closeEventSource() {
    if (!!this.eventSource) {
      this.eventSource.close();
    }
  }

  /**
   * Build query options
   *
   * @param meth POST or GET
   * @param formData data
   */
  private buildOptions(
    meth: string,
    formData?: FormData
  ): {
    payload: FormData;
    method: string;
    headers: HttpHeaders | null;
  } {
    
    const auth = this.authService.upsHttpHeaders;
    return {
      payload: formData,
      method: meth,
      headers: auth,
    };
  }
}
